import WordleApp from './WordleApp';
import './index.css'

export default function WordlePuzzle({isVoteSubmitted}) {
    return <>
    <WordleApp />
    </>
}